import {
    AbstractSearchService,
    SearchResultInterface,
} from 'modules/spravochnik/dt-front-page-generator/src/Search/index';
import {Category} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Category';

export default class CategorySearchService extends AbstractSearchService<Category> {

    filter(res: Array<SearchResultInterface>, element: Category, query: string): void {
        if (query === '') {
            this.append(res, element, null, query);

            for (const page of element.pages) {
                this.append(res, page, element, query);
            }
        } else {
            if (this.like(element, query)) {
                this.append(res, element, null, query);
            } else {
                for (const node of element.pages) {
                    if (this.like(node, query)) {
                        this.append(res, node, element, query);
                    }
                }
            }
        }
    }
}
